import type { MisconceptionDefinition } from '../types'

export const nlRegioStedenMisconceptions: MisconceptionDefinition[] = [
  // ───────────────────────────────────────────────────────────
  // NL — Steden ↔ Provincie (verwarring buurprovincies)
  // ───────────────────────────────────────────────────────────
  {
    id: 'topo.buurprovincie-verward',
    label: 'Buurprovincie verward',
    module: 'Topo',
    description:
      'Leerling kiest een aangrenzende provincie omdat de stad dicht bij de grens ligt (bijv. Almere in Noord-Holland i.p.v. Flevoland).',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO', 'TOPO-NL-STEDEN', 'TOPO-NL-PROV'],
  },
  {
    id: 'topo.holland-noord-zuid-verward',
    label: 'Noord-Holland ↔ Zuid-Holland verward',
    module: 'Topo',
    description:
      'Leerling wisselt Noord-Holland en Zuid-Holland om bij steden in de Randstad.',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO', 'TOPO-NL-STEDEN'],
  },
  {
    id: 'topo.utrecht-stad-vs-provincie',
    label: 'Provincie Utrecht ↔ stad verward',
    module: 'Topo',
    description:
      'Leerling kiest Utrecht voor steden die in een aangrenzende provincie liggen (Hilversum, Naarden) omdat ze dicht bij de stad Utrecht liggen.',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO', 'TOPO-NL-STEDEN'],
  },
  {
    id: 'topo.zuid-vs-noord-confused',
    label: 'Zuidelijke vs. noordelijke provincie verward',
    module: 'Topo',
    description:
      'Leerling kiest een te ver zuidelijke of noordelijke provincie zonder rekening te houden met de werkelijke ligging.',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO', 'TOPO-NL-STEDEN'],
  },
  {
    id: 'topo.oost-vs-west-confused',
    label: 'Oostelijke vs. westelijke provincie verward',
    module: 'Topo',
    description:
      'Leerling kiest een te ver oostelijke of westelijke provincie (bijv. Gelderland i.p.v. Overijssel) bij steden in het binnenland.',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO', 'TOPO-NL-STEDEN'],
  },
  {
    id: 'topo.regio-binnen-provincie-verward',
    label: 'Regio binnen provincie verward',
    module: 'Topo',
    description:
      'Leerling kiest de verkeerde regio binnen een provincie (bijv. Kop van Overijssel i.p.v. Twente).',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO'],
  },
  {
    id: 'topo.stadsdeel-als-eigen-stad',
    label: 'Stadsdeel als zelfstandige stad behandeld',
    module: 'Topo',
    description:
      'Leerling behandelt een stadsdeel of buurgemeente (bijv. Scheveningen) als zelfstandige stad in plaats van als onderdeel van een grotere stad (Den Haag).',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO', 'TOPO-NL-STEDEN'],
  },
  {
    id: 'topo.streek-vs-provincie-verward',
    label: 'Streeknaam met provincienaam verward',
    module: 'Topo',
    description:
      'Leerling denkt dat een streeknaam (Westland, Veluwe, Twente, Achterhoek, Betuwe, Gooi) een eigen provincie is, in plaats van een gebied binnen een provincie.',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO'],
  },
  {
    id: 'topo.veenkolonien-grens-verward',
    label: 'Veenkolonien aan verkeerde provincie gekoppeld',
    module: 'Topo',
    description:
      'Leerling plaatst plaatsen uit de Groninger of Drentse Veenkolonien (Veendam, Stadskanaal, Hoogeveen) aan de verkeerde kant van de provinciegrens.',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO'],
  },
  {
    id: 'topo.hanze-stad-provincie-verward',
    label: 'Hanzestad aan verkeerde provincie gekoppeld',
    module: 'Topo',
    description:
      'Leerling verwart Hanzesteden in Overijssel (Kampen, Deventer, Zwolle) met die in Gelderland (Zutphen, Harderwijk) omdat ze allemaal aan de IJssel liggen.',
    typicalFamilies: ['TOPO-NL-STEDEN-REGIO'],
  },

  // ───────────────────────────────────────────────────────────
  // Hoofdsteden / capitals
  // ───────────────────────────────────────────────────────────
  {
    id: 'topo.hoofdstad-verward-met-grootste',
    label: 'Hoofdstad verward met grootste stad',
    module: 'Topo',
    description:
      'Leerling kiest de grootste stad als hoofdstad of andersom (bijv. Amsterdam i.p.v. Den Haag als regeringsstad).',
    typicalFamilies: ['TOPO-NL-PROV', 'TOPO-EU-HOOFDST', 'TOPO-WERELD-HOOFDST'],
  },
  {
    id: 'topo.hoofdstad-buurland-verward',
    label: 'Hoofdstad van buurland verward',
    module: 'Topo',
    description:
      'Leerling koppelt een hoofdstad aan het verkeerde land (vaak een buurland).',
    typicalFamilies: ['TOPO-EU-HOOFDST', 'TOPO-WERELD-HOOFDST'],
  },
]
